import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import QuoteSection from '../components/QuoteSection';
import LightboxModal from '../components/LightboxModal';
import { companyInfo } from '../data/siteData';
import { imageUrl } from '../lib/images';

export default function PanelhegnPage() {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const images = [
    // 5# Panelhegn og panellåger
    { src: "/_assets/pxl-20260627-112148598-mp.jpg", title: "Galvaniseret panelhegn omkring sandareal" },
    { src: "/_assets/pxl-20260531-083822023.jpg", title: "Sort panelhegn og panellåge ved terrasse" },
    { src: "/_assets/pxl-20260508-133014856.jpg", title: "Sort dobbelttråds panelhegn langs have" },
    { src: "/_assets/img20251223131731.jpg", title: "Galvaniseret panelhegn langs grusvej" },
    { src: "/_assets/pxl-20260626-182849918-mp.jpg", title: "Galvaniseret dobbelt panellåge og hegn" },
    { src: "/_assets/pxl-20260531-083803960.jpg", title: "Sort panellåge ved murstensvæg" },
    { src: "/_assets/img20251224093853.jpg", title: "Galvaniseret panellåge ved depotrum" },
    // Øvrige referencer
    { src: "/_assets/490153135-1329555835199280-767963427889470727-n-0.jpg", title: "Panelhegn" },
    { src: "/_assets/panelhegn2.jpeg", title: "Panelhegn sort" },
    { src: "/_assets/panelhegn5-1.jpeg", title: "Panelhegn i have" },
    { src: "/_assets/panelhegn4-1.jpeg", title: "Panelhegn i Odense" },
    { src: "/_assets/panelhegn3.jpeg", title: "Panelhegn i Danmark" },
    { src: "/_assets/327032265-938137584260657-5283060228493626441-n.jpg", title: "Panelhegn i Aalborg" },
    { src: "/_assets/333571161-1143977852939452-4405149958717881853-n.jpg", title: "Panelhegn i Gentofte" },
    { src: "/_assets/thumbnail-1000003866.jpg", title: "Panelhegn erhverv" },
    { src: "/_assets/thumbnail-1000003902.jpg", title: "Panelhegn virksomheder" },
    { src: "/_assets/thumbnail-1000003903.jpg", title: "Panelhegn virksomhed" },
    { src: "/_assets/thumbnail-img20250219132431.jpg", title: "Panelhegn industri" },
    { src: "/_assets/1000003297.jpg", title: "Panelhegn havemontage" },
    { src: "/_assets/thumbnail-1000003459.jpg", title: "Panelhegn Hovendals" },
    { src: "/_assets/thumbnail-1000003512.jpg", title: "Panelhegn på landet" },
  ];

  return (
    <>
      <SEO
        title="Panelhegn til hele Danmark | Vi holder til i Odense | Få tilbud"
        description="Panelhegn er stærkt stålhegn, der er nemt at vedligeholde. Hos Hovendals er vi eksperter og hjælper gerne dig. Kontakt os i dag for et tilbud."
        ogImage="/_assets/panelhegn4.jpeg"
      />

      {/* Hero */}
      <section className="relative py-20 bg-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-25">
          <img
            src={imageUrl("/_assets/panelhegn4.jpeg", "width=1600,quality=80,format=auto")}
            alt="Panelhegn"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-[#004fa4]/20 text-[#c2ccdf] border border-[#004fa4]/30">
              <i className="fa-sharp fa-solid fa-shield-halved" aria-hidden="true"></i>
              <span>Stærkt stålhegn</span>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Panelhegn til sikkerhed og tryghed
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed font-normal">
              Panelhegn er et stærkt stålhegn, der samtidig er let at vedligeholde og ideelt til både haver og erhvervsejendomme.
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="space-y-6">
              <div>
                <span className="text-xs font-bold uppercase tracking-wider text-[#004fa4]">Sikker afgrænsning</span>
                <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight mt-1">
                  Indhegning med stil og styrke
                </h2>
              </div>

              <p className="text-slate-700 leading-relaxed text-base">
                Skal du have et hegn, der skal kunne holde ubudne gæster væk? Eller skal haven hegnes ind, så hunden ikke løber ud på eventyr? Så kan et panelhegn være den rette løsning for dig.
              </p>

              <p className="text-slate-700 leading-relaxed text-base">
                Hos <Link to="/" className="text-[#004fa4] font-bold hover:underline">Hovendals ApS</Link> laver vi alle vores panelhegn på mål til kunder i Odense, Aalborg, Silkeborg, Gentofte og resten af Danmark. Vi kommer ud og måler op, hvorpå vi laver hegnet på vores værksted. På den måde kan du være helt sikker på, at panelhegnet er designet efter dine ønsker.
              </p>

              <p className="text-slate-700 leading-relaxed text-base">
                Vi sørger for, at du hurtig kan nyde godt af det nye hegn. Vi kommer naturligvis ud og monterer hegnet, når det er færdigt. Vi har flere års erfaring med forskellige typer af panelhegn. Hvis du ønsker at få en ny låge, der matcher dit hegn, så tilbyder vi også det. Det kan både være en <Link to="/panellaage" className="text-[#004fa4] font-bold hover:underline">panelhegnslåge</Link>, men det kan også være en <Link to="/smedejernslaage" className="text-[#004fa4] font-bold hover:underline">smedejernslåge</Link>, som har en kraftigere struktur.
              </p>

              <div className="flex flex-wrap gap-4 pt-2">
                <a
                  href={`tel:${companyInfo.phoneFormatted}`}
                  className="px-6 py-3 rounded-lg bg-[#004fa4] hover:bg-[#183e7f] text-white font-medium text-sm shadow-sm transition-all flex items-center gap-2"
                >
                  <i className="fa-sharp fa-solid fa-phone" aria-hidden="true"></i>
                  <span>Ring: {companyInfo.phone}</span>
                </a>
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="px-6 py-3 rounded-lg bg-slate-900 hover:bg-slate-800 text-white font-bold text-sm transition-all flex items-center gap-2"
                >
                  <i className="fa-sharp fa-solid fa-envelope" aria-hidden="true"></i>
                  <span>Skriv en mail</span>
                </a>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden shadow-xl border-4 border-white bg-slate-100">
              <img
                src={imageUrl("/_assets/panelhegn.webp", "width=1200,quality=85,format=auto")}
                alt="Panelhegn i have"
                className="w-full h-auto aspect-[16/10] object-cover"
              />
            </div>
          </div>

          {/* Section: Hvad er et panelhegn? */}
          <div className="bg-slate-50 rounded-2xl p-8 sm:p-12 border border-slate-200/80 mb-16">
            <div className="max-w-3xl space-y-4">
              <span className="text-xs font-bold uppercase tracking-wider text-[#004fa4]">Materialer & holdbarhed</span>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
                Hvad er et panelhegn?
              </h2>
              <p className="text-slate-700 leading-relaxed text-base">
                Panelhegn er et stærkt stålhegn, der samtidig er let at vedligeholde. Vi kan også levere det i en galvaniseret udgave, som er en kemisk proces, hvor stålet gives en zinkbelægning. Udover den galvaniseret version, kan du også få hegnet i sort og grøn.
              </p>
              <p className="text-slate-700 leading-relaxed text-base">
                Panelhegn er en populær form for hegn, som typisk anvendes til at omkranse industriområder, fodboldbaner og institutioner. I takt med tiden er anvendelsen af denne type hegn dog blevet mere udbredt, og det er også en populær hegnsløsning hos private.
              </p>
              <p className="text-slate-700 leading-relaxed text-base">
                Panelhegnene tilpasser vi til forskellige formål og miljøer, og du kan derfor anvende det både til sikring af store områder og til at skabe en mere privat atmosfære i haven. Med denne type hegn får du samtidig en holdbar og vedligeholdelsesfri løsning, der kan modstå vind og vejr. Vi tilbyder desuden en <Link to="/panellaage" className="text-[#004fa4] font-bold hover:underline">panellåge</Link>, der vil passe perfekt til.
              </p>
              <div className="pt-2">
                <Link
                  to="/kontakt"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-[#004fa4] hover:bg-[#183e7f] text-white font-medium text-sm shadow-sm transition-all"
                >
                  <span>Hør mere om panelhegn</span>
                  <i className="fa-sharp fa-solid fa-arrow-right text-xs" aria-hidden="true"></i>
                </Link>
              </div>
            </div>
          </div>

          {/* Vedligeholdelse */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            <div className="p-8 rounded-2xl bg-white border border-slate-200 shadow-sm space-y-3">
              <div className="w-12 h-12 rounded-xl bg-[#004fa4]/10 text-[#004fa4] flex items-center justify-center text-xl">
                <i className="fa-sharp fa-solid fa-soap" aria-hidden="true"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900">
                Vedligeholdelse af panelhegn
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                Vedligeholdelse af et panelhegn er minimalt. Det kræver kun vask, hvis det er ramt af alger eller bliver beskidt med tiden. Så du slipper for at skulle tænke på maling og forrådnelse.
              </p>
              <p className="text-slate-600 text-sm leading-relaxed">
                Desuden har denne type hegn en lang levetid. Med galvaniseret stolper og hegnsfag vil der gå rigtig mange år, før du behøver at tænke på at udskifte det.
              </p>
            </div>

            <div className="p-8 rounded-2xl bg-slate-900 text-white shadow-sm space-y-4">
              <div className="w-12 h-12 rounded-xl bg-[#004FA4] text-white flex items-center justify-center text-xl font-bold">
                <i className="fa-sharp fa-solid fa-comments-question" aria-hidden="true"></i>
              </div>
              <h3 className="text-xl font-bold text-white">
                Skal du have hjælp eller vil du vide mere om panelhegn?
              </h3>
              <p className="text-slate-300 text-sm leading-relaxed">
                Sidder du med spørgsmål vedrørende vores panelhegn, så er du mere end velkommen til at kontakte os på telefon <a href={`tel:${companyInfo.phoneFormatted}`} className="text-[#c2ccdf] font-bold hover:underline">{companyInfo.phone}</a>, så tager vi en uforpligtende snak. Du kan også sende en mail til <a href={`mailto:${companyInfo.email}`} className="text-[#c2ccdf] font-bold hover:underline">{companyInfo.email}</a> og så vender vi hurtigst muligt tilbage eller udfyld vores kontaktformular.
              </p>
              <div className="pt-2">
                <Link
                  to="/kontakt"
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-[#004fa4] hover:bg-[#183e7f] text-white font-medium text-sm transition-all"
                >
                  <span>Kontakt os i dag</span>
                  <i className="fa-sharp fa-solid fa-arrow-right text-xs" aria-hidden="true"></i>
                </Link>
              </div>
            </div>
          </div>

          {/* Billedgalleri */}
          <div className="mb-16">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h3 className="text-2xl font-bold text-slate-900">
                  Panelhegn billedgalleri
                </h3>
                <p className="text-sm text-slate-600 mt-1">
                  Se eksempler på panelhegn hos private haver og virksomheder.
                </p>
              </div>
              <Link to="/galleri/panelhegn" className="text-sm font-bold text-[#004fa4] hover:text-[#183e7f]">
                Se galleriside &rarr;
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
              {images.map((img, idx) => (
                <div
                  key={idx}
                  onClick={() => setLightboxIndex(idx)}
                  className="group relative h-40 rounded-xl overflow-hidden bg-slate-100 cursor-pointer shadow-sm hover:shadow-md transition-all"
                >
                  <img
                    src={imageUrl(img.src, "width=400,quality=80,format=auto")}
                    alt={img.title}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-slate-950/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center text-white">
                    <span className="p-2 rounded-full bg-[#143463]/90 text-white text-xs">
                      <i className="fa-sharp fa-solid fa-magnifying-glass-plus" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <QuoteSection />

      {/* Lightbox Modal */}
      <LightboxModal
        images={images}
        currentIndex={lightboxIndex}
        onClose={() => setLightboxIndex(null)}
        onNavigate={(index) => setLightboxIndex(index)}
      />
    </>
  );
}
